import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

Vue.use(Vuex);

const FormatTypesVuexModule = {
  namespaced: true,
  state: () => ({
    $_moduleApiPath: "v1.0/FormatTypes",
    $_formatTypes: [],
    $_currentFormatType: {},
    $_errorState: {},
    $_actionState: {
      message: "",
      status: 200,
      data: {}
    }
  }),
  getters: {
    allFormatTypes: state => state.$_formatTypes,
    currentFormatType: state => state.$_currentFormatType,
    actionState: state => state.$_actionState,
    errorState: state => state.$_errorState
  },
  actions: {
    initFormatType({ commit }) {
      var formatType = {
        id: 0,
        description: "",
        isActive: false
      };

      commit("SET_FORMAT_TYPE", formatType);
    },
    clearFormatTypes({ commit }) {
      commit("SET_FORMAT_TYPES", []);
    },
    setFormatType({ commit }, formatType) {
      commit("SET_FORMAT_TYPE", formatType);
    },
    async getFormatTypes({ commit, dispatch, state, rootGetters }) {
      var baseUrl = rootGetters.baseUrl;
      var actionLink = baseUrl + state.$_moduleApiPath;
      var axiosConfig = rootGetters.axiosConfig;
      try {
        const response = await axios.get(actionLink, axiosConfig);
        commit("SET_FORMAT_TYPES", response.data);
      } catch (error) {
        commit("SET_ERROR", error);
        await dispatch("handleUnauthorizedError", error, {
          root: true
        });
      }
    },

    async getFormatType({ commit, dispatch, state, rootGetters }, id) {
      var baseUrl = rootGetters.baseUrl;
      var actionLink = baseUrl + state.$_moduleApiPath + "/" + id;
      var axiosConfig = rootGetters.axiosConfig;
      try {
        const response = await axios.get(actionLink, axiosConfig);
        commit("SET_FORMAT_TYPE", response.data);
      } catch (error) {
        commit("SET_ERROR", error);
        await dispatch("handleUnauthorizedError", error, {
          root: true
        });
      }
    },

    async createFormatType(
      { commit, dispatch, state, rootGetters },
      formatType
    ) {
      var baseUrl = rootGetters.baseUrl;
      var actionLink = baseUrl + state.$_moduleApiPath;
      var axiosConfig = rootGetters.axiosConfig;
      try {
        formatType.id = 0;
        const response = await axios.post(
          actionLink,
          formatType,
          axiosConfig
        );
        formatType.id = response.data.id;
        commit("SET_FORMAT_TYPE", formatType);
      } catch (error) {
        commit("SET_ERROR", error);
        await dispatch("handleUnauthorizedError", error, {
          root: true
        });
      }
    },
    async updateFormatType(
      { commit, dispatch, state, rootGetters },
      data
    ) {
      var baseUrl = rootGetters.baseUrl;
      var actionLink = baseUrl + state.$_moduleApiPath + "/" + data.id;
      var axiosConfig = rootGetters.axiosConfig;
      try {
        const response = await axios.put(
          actionLink,
          data.formatType,
          axiosConfig
        );
        data.formatType.id = response.data.id;

        commit("SET_FORMAT_TYPE", data.formatType);
      } catch (error) {
        commit("SET_ERROR", error);
        await dispatch("handleUnauthorizedError", error, {
          root: true
        });
      }
    }
  },
  mutations: {
    SET_FORMAT_TYPES(state, value) {
      state.$_formatTypes = value;
    },
    SET_FORMAT_TYPE(state, value) {
      state.$_currentFormatType = value;
    },
    SET_ERROR(state, value) {
      state.$_errorState = value;
    }
  }
};

export default FormatTypesVuexModule;
